import { Popover } from 'antd';
import React, { useState } from 'react';
import RelationsDetail from './RelationsDetail';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { track } from '../../tracking';

export const RelatedProfilesPopoverWrapper: React.FC<{
    pid: string;
    placement: TooltipPlacement;
    getPopupContainer?: () => HTMLElement;
    from: string;
    onRefresh?: () => Promise<void>;
}> = ({ pid, placement, children, getPopupContainer, from, onRefresh }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [visible, setVisible] = useState(false);
    const onVisibleChange = (visible: boolean): void => {
        setVisible(visible);
        if (visible) {
            track('RELATED_PROFILES_POPOVER_VISIBLE', { from });
        } else {
            onRefresh && onRefresh();
        }
    };
    return (
        <Popover
            content={
                <RelationsDetail
                    pid={pid}
                    closeMe={() => onVisibleChange(false)}
                    dispatch={dispatch}
                    history={history}
                    from={from}
                />
            }
            title={null}
            trigger={'click'}
            placement={placement}
            destroyTooltipOnHide
            zIndex={1000}
            overlayClassName="popover-p-0 patient-health-summary-popover"
            visible={visible}
            onVisibleChange={onVisibleChange}
            getPopupContainer={getPopupContainer}
        >
            {children}
        </Popover>
    );
};
